import { useRootAppStore } from "@hooks";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { StorageStateKeysEnum } from "@utils/storage";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

export const NotificationInfo = observer(function NotificationInfo(props: {
	isSidebar?: boolean;
}) {
	const { t } = useTranslation("notification-settings");
	const { localStorageProvider } = useRootAppStore();
	const [notificationStatus, setNotificationStatus] = useState(
		localStorageProvider.get(
			StorageStateKeysEnum.NOTIFICATION_INFO_CLOSED
		) || 0
	);

	if (notificationStatus || !isCapacitorPlatform()) {
		return null;
	}

	if (props.isSidebar) {
		return (
			<small className="nav--secondary__description nav--secondary__description--info">
				<span>{t("NOTIFICATION_INFO_CONTENT")}</span>
				<button
					type="button"
					className="btn btn--icon btn--square btn--square--mic btn--ghost btn--icon"
					onClick={() => {
						setNotificationStatus(1);
						localStorageProvider.set(
							StorageStateKeysEnum.NOTIFICATION_INFO_CLOSED,
							1
						);
					}}
				>
					<i className="u-icon u-icon--tny u-icon--close" />
				</button>
			</small>
		);
	}

	return (
		<div className="nav--secondary__description nav--secondary__description--info">
			<ReactMarkdown>{t("NOTIFICATION_INFO_CONTENT")}</ReactMarkdown>

			<button
				type="button"
				className="card--info__btn btn btn--icon btn--square btn--square--xsml btn--ghost btn--icon"
				onClick={() => {
					setNotificationStatus(1);
					localStorageProvider.set(
						StorageStateKeysEnum.NOTIFICATION_INFO_CLOSED,
						1
					);
				}}
			>
				<i className="u-icon u-icon--tny u-icon--close" />
			</button>
		</div>
	);
});
